module.exports = __webpack_public_path__ + "img/Metal038_1K_Roughness.a8a57594.jpg";